import { IconButton, InputAdornment } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";

type PasswordAdornmentProps = {
    show: boolean;
    toggleShow: () => void;
    color?: string;
};

export default function PasswordAdornment({ show, toggleShow, color = "#003367" }: PasswordAdornmentProps) {
    return (
        <InputAdornment position="end">
            <IconButton
                onClick={toggleShow}
                edge="end"
                aria-label={show ? "Hide password" : "Show password"}
                sx={{ color }}
            >
                {show ? <VisibilityOff /> : <Visibility />}
            </IconButton>
        </InputAdornment>
    );
}